<script setup lang="ts">
import { computed } from 'vue';
import FormFieldMessages from '@shared/common/form/application/component/FormFieldMessages.vue';
import type { RichTextFormField } from '@shared/common/form/domain/form/field/rich-text.form-field';
import InputRichTextEditor from '@shared/common/form/application/component/rich-text/InputRichTextEditor.vue';

const model = defineModel<RichTextFormField>({ required: true });

const editorValue = computed<string>({
  get: () => model.value.value ?? '',
  set: (value: string) => {
    model.value.value = value.length ? value : null;
  },
});

const message = computed(() => model.value.errorMessages?.[0]);
const additionalErrors = computed(() => model.value.errorMessages?.slice(1));
</script>

<template>
  <div>
    <InputRichTextEditor
      :id="model.id"
      v-model="editorValue"
      :label="model.label"
      :hint="model.hint"
      :placeholder="model.placeholder"
      :disabled="model.disabled"
      :readonly="model.readonly"
      :error="message"
    />
    <FormFieldMessages :errors="additionalErrors" />
  </div>
</template>
